import { CommonMessages, CommonMessagesContext } from '@ui-components/context/CommonMessages'
import { ReactNode } from 'react'
import { useIntl } from 'react-intl'

export const CommonMessagesProvider = ({ children }: { children: ReactNode }) => {
  const { formatMessage } = useIntl()

  const value = {
    opensInANewTab: formatMessage({ id: 'common-opens-in-a-new-tab' }),
  } satisfies CommonMessages

  return <CommonMessagesContext value={value}>{children}</CommonMessagesContext>
}
